import { render } from "./RegisterTerminal.vue?vue&type=template&id=412ffe87&scoped=true"
import script from "./RegisterTerminal.vue?vue&type=script&lang=js"
export * from "./RegisterTerminal.vue?vue&type=script&lang=js"

import "./RegisterTerminal.vue?vue&type=style&index=0&id=412ffe87&scoped=true&lang=css"

import exportComponent from "/var/www/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-412ffe87"]])

export default __exports__